export default __webpack_public_path__ + "static/media/card2-1920x1080Tiny.8d0bb883.png";